var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { PageBody, PageContent, PageHeader, PageSide, PageFooter, PageText } from './styles';
import MagazineNode from './components/MagazineNode';
import useCommonProps from '../../../../../hooks/useCommonProps';
var COLORED_POST_MIN_LINES = 3;
var Gap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 9mm;\n"], ["\n  height: 9mm;\n"])));
var MeasureTemlate = function (_a) {
    var posts = _a.posts, setMagazineBlocks = _a.setMagazineBlocks;
    var container = useRef();
    var _b = useState([]), childHeights = _b[0], setChildHeights = _b[1];
    var _c = useState(0), bodyHeight = _c[0], setBodyHeight = _c[1];
    var _d = useState(0), lineHeight = _d[0], setLineHeight = _d[1];
    var _e = useState(0), gapHeight = _e[0], setGapHeight = _e[1];
    var textRef = useRef();
    var gapRef = useRef();
    var magazineData = useCommonProps().magazineData;
    useEffect(function () {
        if (childHeights.length && bodyHeight) {
            var calculateItemHeights_1 = function () {
                var magazineBlocks = posts.reduce(function (acc, post, index) {
                    var _a, _b, _c, _d;
                    var _e, _f;
                    var currentPageHeight = acc.currentPageHeight, pages = acc.pages, currentPage = acc.currentPage;
                    var postHeight = childHeights[index];
                    var totalPostHeight = postHeight + gapHeight;
                    var nextEmptyPage = Object.keys(pages).length + 1;
                    // console.log('poop totalPostHeight', totalPostHeight)
                    // console.log('poop currentPage', currentPage)
                    // console.log('poop currentPageHeight', currentPageHeight)
                    if (post.style === 'magazine_title') {
                        return {
                            currentPageHeight: 0,
                            pages: { 0: [post] },
                            currentPage: nextEmptyPage
                        };
                    }
                    if (post.style === 'image') {
                        var _g = ((_f = (_e = post.attachments) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.originalImageInfo) || {}, width = _g.width, height = _g.height;
                        var isVertical = width / height < 1;
                        if (isVertical) {
                            return __assign(__assign({}, acc), { pages: __assign(__assign({}, pages), (_a = {}, _a[nextEmptyPage] = [post], _a)) });
                        }
                    }
                    if (post.style === 'colored' &&
                        postHeight < COLORED_POST_MIN_LINES * lineHeight) {
                        var nextBlockIndex = posts.findIndex(function (p, i) { return i > index && ['colored', 'normal'].includes(p.style); });
                        if (nextBlockIndex !== -1) {
                            var nextBlockHeight = childHeights[nextBlockIndex];
                            if (currentPageHeight +
                                postHeight +
                                nextBlockHeight +
                                2 * gapHeight >
                                bodyHeight) {
                                return {
                                    currentPageHeight: postHeight,
                                    pages: __assign(__assign({}, pages), (_b = {}, _b[nextEmptyPage] = [post], _b)),
                                    currentPage: nextEmptyPage
                                };
                            }
                        }
                    }
                    var currentPageContent = pages[currentPage] || [];
                    if (currentPageHeight + totalPostHeight > bodyHeight) {
                        var newPageContent_1 = [post];
                        return {
                            currentPageHeight: postHeight,
                            pages: __assign(__assign({}, pages), (_c = {}, _c[nextEmptyPage] = newPageContent_1, _c)),
                            currentPage: nextEmptyPage
                        };
                    }
                    var newPageContent = __spreadArray(__spreadArray([], currentPageContent, true), [post], false);
                    return {
                        currentPageHeight: currentPageHeight + totalPostHeight,
                        pages: __assign(__assign({}, pages), (_d = {}, _d[currentPage] = newPageContent, _d)),
                        currentPage: currentPage
                    };
                }, {
                    currentPage: 1,
                    currentPageHeight: 0,
                    pages: {}
                });
                var values = Object.values(magazineBlocks.pages);
                var splitMagazineBlocks = Array.from({ length: Math.ceil(values.length / 2) }, function (_, i) { var _a; return [values[i * 2], (_a = values[i * 2 + 1]) !== null && _a !== void 0 ? _a : null]; }).map(function (pages) { return ({
                    pages: pages,
                    printType: 'magazine'
                }); });
                var titlePage = {
                    pages: [
                        [
                            {
                                text: magazineData === null || magazineData === void 0 ? void 0 : magazineData.author,
                                style: 'magazine_author'
                            },
                            {
                                text: magazineData === null || magazineData === void 0 ? void 0 : magazineData.title,
                                style: 'magazine_title'
                            }
                        ],
                        [
                            {
                                attachments: [
                                    {
                                        files: magazineData === null || magazineData === void 0 ? void 0 : magazineData.titleImages
                                    }
                                ],
                                style: 'image'
                            }
                        ]
                    ],
                    printType: 'magazine'
                };
                setMagazineBlocks(__spreadArray([titlePage], splitMagazineBlocks, true));
            };
            document.fonts.ready.then(function () { return calculateItemHeights_1(); }).catch(function () { });
        }
    }, [posts, childHeights]);
    useEffect(function () {
        var _a;
        var measure = function () {
            var node = container.current;
            if (!node)
                return;
            var children = Array.from(node.children);
            var sizes = children.map(function (child, index) {
                var rect = child.getBoundingClientRect();
                return rect.height;
            });
            setChildHeights(sizes);
            setBodyHeight(node.getBoundingClientRect().height);
            setLineHeight(textRef.current.getBoundingClientRect().height);
            setGapHeight(gapRef.current.getBoundingClientRect().height);
        };
        var rafId = window.requestAnimationFrame(measure);
        if ((_a = document === null || document === void 0 ? void 0 : document.fonts) === null || _a === void 0 ? void 0 : _a.ready) {
            document.fonts.ready.then(function () { return measure(); }).catch(function () { });
        }
        return function () {
            window.cancelAnimationFrame(rafId);
        };
    }, [posts]);
    return (React.createElement(PageContent, null,
        React.createElement(PageSide, null,
            React.createElement(PageHeader, null),
            React.createElement(PageBody, { ref: container },
                React.createElement(MagazineNode, { posts: posts })),
            React.createElement(PageFooter, null)),
        React.createElement(PageBody, null,
            React.createElement(PageText, { ref: textRef }, "MeasureTemlate"),
            React.createElement(Gap, { ref: gapRef })),
        React.createElement(PageSide, { position: 'right' })));
};
export default MeasureTemlate;
var templateObject_1;
//# sourceMappingURL=MeasureTemlate.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { PageBody, PageContent, PageHeader, PageSide, PageFooter, PageText } from './styles';
import MagazineNode from './components/MagazineNode';
import useCommonProps from '../../../../../hooks/useCommonProps';
var COLORED_POST_MIN_LINES = 3;
var Gap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 9mm;\n"], ["\n  height: 9mm;\n"])));
var MeasureTemlate = function (_a) {
    var posts = _a.posts, setMagazineBlocks = _a.setMagazineBlocks;
    var container = useRef();
    var _b = useState([]), childHeights = _b[0], setChildHeights = _b[1];
    var _c = useState(0), bodyHeight = _c[0], setBodyHeight = _c[1];
    var _d = useState(0), lineHeight = _d[0], setLineHeight = _d[1];
    var _e = useState(0), gapHeight = _e[0], setGapHeight = _e[1];
    var textRef = useRef();
    var gapRef = useRef();
    var magazineData = useCommonProps().magazineData;
    useEffect(function () {
        if (childHeights.length && bodyHeight) {
            var calculateItemHeights_1 = function () {
                var magazineBlocks = posts.reduce(function (acc, post, index) {
                    var _a, _b, _c, _d;
                    var _e, _f;
                    var currentPageHeight = acc.currentPageHeight, pages = acc.pages, currentPage = acc.currentPage;
                    var postHeight = childHeights[index];
                    var totalPostHeight = postHeight + gapHeight;
                    var nextEmptyPage = Object.keys(pages).length + 1;
                    // console.log('poop totalPostHeight', totalPostHeight)
                    // console.log('poop currentPage', currentPage)
                    // console.log('poop currentPageHeight', currentPageHeight)
                    if (post.style === 'magazine_title') {
                        return {
                            currentPageHeight: 0,
                            pages: { 0: [post] },
                            currentPage: nextEmptyPage
                        };
                    }
                    if (post.style === 'image') {
                        var _g = ((_f = (_e = post.attachments) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.originalImageInfo) || {}, width = _g.width, height = _g.height;
                        var isVertical = width / height < 1;
                        if (isVertical) {
                            return __assign(__assign({}, acc), { pages: __assign(__assign({}, pages), (_a = {}, _a[nextEmptyPage] = [post], _a)) });
                        }
                    }
                    if (post.style === 'colored' &&
                        postHeight < COLORED_POST_MIN_LINES * lineHeight) {
                        var nextBlockIndex = posts.findIndex(function (p, i) { return i > index && ['colored', 'normal'].includes(p.style); });
                        if (nextBlockIndex !== -1) {
                            var nextBlockHeight = childHeights[nextBlockIndex];
                            if (currentPageHeight +
                                postHeight +
                                nextBlockHeight +
                                2 * gapHeight >
                                bodyHeight) {
                                return {
                                    currentPageHeight: postHeight,
                                    pages: __assign(__assign({}, pages), (_b = {}, _b[nextEmptyPage] = [post], _b)),
                                    currentPage: nextEmptyPage
                                };
                            }
                        }
                    }
                    var currentPageContent = pages[currentPage] || [];
                    if (currentPageHeight + totalPostHeight > bodyHeight) {
                        var newPageContent_1 = [post];
                        return {
                            currentPageHeight: postHeight,
                            pages: __assign(__assign({}, pages), (_c = {}, _c[nextEmptyPage] = newPageContent_1, _c)),
                            currentPage: nextEmptyPage
                        };
                    }
                    var newPageContent = __spreadArray(__spreadArray([], currentPageContent, true), [post], false);
                    return {
                        currentPageHeight: currentPageHeight + totalPostHeight,
                        pages: __assign(__assign({}, pages), (_d = {}, _d[currentPage] = newPageContent, _d)),
                        currentPage: currentPage
                    };
                }, {
                    currentPage: 1,
                    currentPageHeight: 0,
                    pages: {}
                });
                var values = Object.values(magazineBlocks.pages);
                var splitMagazineBlocks = Array.from({ length: Math.ceil(values.length / 2) }, function (_, i) { var _a; return [values[i * 2], (_a = values[i * 2 + 1]) !== null && _a !== void 0 ? _a : null]; }).map(function (pages) { return ({
                    pages: pages,
                    printType: 'magazine'
                }); });
                var titlePage = {
                    pages: [
                        [
                            {
                                text: magazineData === null || magazineData === void 0 ? void 0 : magazineData.author,
                                style: 'magazine_author'
                            },
                            {
                                text: magazineData === null || magazineData === void 0 ? void 0 : magazineData.title,
                                style: 'magazine_title'
                            }
                        ],
                        [
                            {
                                attachments: [
                                    {
                                        files: magazineData === null || magazineData === void 0 ? void 0 : magazineData.titleImages
                                    }
                                ],
                                style: 'image'
                            }
                        ]
                    ],
                    printType: 'magazine'
                };
                setMagazineBlocks(__spreadArray([titlePage], splitMagazineBlocks, true));
            };
            document.fonts.ready.then(function () { return calculateItemHeights_1(); }).catch(function () { });
        }
    }, [posts, childHeights]);
    useEffect(function () {
        var _a;
        var measure = function () {
            var node = container.current;
            if (!node)
                return;
            var children = Array.from(node.children);
            var sizes = children.map(function (child, index) {
                var rect = child.getBoundingClientRect();
                return rect.height;
            });
            setChildHeights(sizes);
            setBodyHeight(node.getBoundingClientRect().height);
            setLineHeight(textRef.current.getBoundingClientRect().height);
            setGapHeight(gapRef.current.getBoundingClientRect().height);
        };
        var rafId = window.requestAnimationFrame(measure);
        if ((_a = document === null || document === void 0 ? void 0 : document.fonts) === null || _a === void 0 ? void 0 : _a.ready) {
            document.fonts.ready.then(function () { return measure(); }).catch(function () { });
        }
        return function () {
            window.cancelAnimationFrame(rafId);
        };
    }, [posts]);
    return (React.createElement(PageContent, null,
        React.createElement(PageSide, null,
            React.createElement(PageHeader, null),
            React.createElement(PageBody, { ref: container },
                React.createElement(MagazineNode, { posts: posts })),
            React.createElement(PageFooter, null)),
        React.createElement(PageBody, null,
            React.createElement(PageText, { ref: textRef }, "MeasureTemlate"),
            React.createElement(Gap, { ref: gapRef })),
        React.createElement(PageSide, { position: 'right' })));
};
export default MeasureTemlate;
var templateObject_1;
//# sourceMappingURL=MeasureTemlate.js.map